<h2 mat-dialog-title class="">{{data?.title}}</h2>
<mat-dialog-content>
    <ng-container *ngIf="data.mode !== 'delete'; else deleteMode">
        <div class="row mb-3 p-3 w-100">
            <form [formGroup]="form" class="row g-3">
                <div class="col-md-12 mb-3">
                    <div class="card">
                        <div class="card-body">
                            <div class="carousel-preview-container">
                                <img 
                                [src]="photoPreview || 'assets/Images/no-image.jpg'" 
                                alt="Carousel image" 
                                class="carousel-preview-image" />
                            </div>
                            <div class="upload-button-container" (click)="uploadFoto()">
                                <button type="button" class="btn btn-primary">
                                Subir foto
                                </button><label class="text-danger">*</label>
                            </div>
                            <div class="d-none">
                                <input type="file" accept="image/*" id="fileFoto" (change)="onPhotoSelected($event)">
                            </div>
                        </div>
                        <app-form-errors [controlName]="form.controls['fileId']"></app-form-errors>
                    </div>
                </div>
                <div class="col-md-6 mb-3">
                    <label for="startDate" class="form-label">Fecha de inicio</label><label class="text-danger">*</label>
                    <input type="date" id="startDate" class="form-control" formControlName="startDate" />
                    <app-form-errors [controlName]="form.controls['startDate']"></app-form-errors>
                </div>
                <div class="col-md-6 mb-3">
                    <label for="endDate" class="form-label">Fecha de fin</label><label class="text-danger">*</label>
                    <input type="date" id="endDate" class="form-control" formControlName="endDate" />
                    <app-form-errors [controlName]="form.controls['endDate']"></app-form-errors>
                </div>
            </form>
        </div>
    </ng-container>
    <ng-template #deleteMode>
        <div class="">
            <div class="">
                <h5>¿Seguro que quieres eliminar?</h5>
            </div>
        </div>
    </ng-template>
</mat-dialog-content>
<mat-dialog-actions align="end">
    <button mat-raised-button class="btn btn-primary btn-lg me-3" (click)="Accept()">{{data.mode === 'delete' ? 'Eliminar' : 'Guardar'}}</button>
    <button mat-button class="btn btn-danger btn-lg" (click)="closeDialog(false)">Cancelar</button>
</mat-dialog-actions>